var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    staticClass: "product-accessory-form",
    attrs: {
      "title": _vm.$t('titles.addAccessory'),
      "playground": ""
    },
    on: {
      "hidden": _vm.resetForm
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-modal-body"
  }, [_c('product-combobox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.product,
      "filter": {
        bundle: false,
        omittedIds: this.unselectableProductIds
      }
    },
    model: {
      value: (_vm.form.model.product),
      callback: function($$v) {
        _vm.form.model.product = $$v
      },
      expression: "form.model.product"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer uk-text-right"
  }, [_c('submit-button', {
    attrs: {
      "disabled": !_vm.isSubmittable,
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.add')))]), _vm._v(" "), _c('common-button', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.cancel')))])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e065642","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductAccessoryForm.vue
// module id = 1917
// module chunks = 0